module.exports = __webpack_public_path__ + "img/icn_brand6_black.1e05ea68.svg";